import React from 'react';
import { makeStyles } from 'tss-react/mui';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import GreenThumbImage from 'assets/illustrations/Thumbs-up-star.png';

const useStyles = makeStyles()(() => ({
  thumbsUp: {
    width: 120,
    height: 'auto',
  },
}));

interface VerificationStatusContentProps {
  isSuccess: boolean;
}

const VerificationStatusContent: React.FC<VerificationStatusContentProps> = ({ isSuccess }) => {
  const { classes } = useStyles();

  return (
    <Box display='flex' height={260} flexDirection='column' alignItems='center' justifyContent='center'>
      {isSuccess ? (
        <>
          <img src={GreenThumbImage} alt='thumbs-up' className={classes.thumbsUp} />
          <Typography variant='bodyRegular' fontWeight={600}>
            Registration Successful
          </Typography>
        </>
      ) : (
        <CircularProgress size={90} sx={{ mb: 4 }} />
      )}

      <Typography variant='captionRegular'>
        {isSuccess ? 'Please wait while we generate your Credit Score…' : 'Verifying...'}
      </Typography>
    </Box>
  );
};

export default VerificationStatusContent;
